module.exports = __webpack_public_path__ + "c045b73d86803686f4cd1cc3f9ceba59.ttf";